import useU2000LocalStorage from "./U2000UseLocalStorage";

function useU2000ToggleLocalStorage(key: string, initValue: boolean): [boolean, (value?: boolean) => void] {
  const [value, setValue] = useU2000LocalStorage<boolean>(key, initValue);

  const toggle = (value?: boolean) => {
    setValue((prev) => {
      return typeof value === "boolean" ? value : !prev;
    });
  };

  return [value, toggle];
}

export default useU2000ToggleLocalStorage;
